import * as Three from 'three';
import React from 'react';

export default {
    name: '[pipe]vertical-water-pipe',
    prototype: 'holes',

    info: {
        tag: ['structure'],
        title: 'vertical pipe',
        description: 'vertical water pipe',
        image: require('./verticalPipe.png')
    },

    properties: {
        width: {
            label: 'Width',
            type: 'length-measure',
            defaultValue: {
                length: 30
            }
        },
        length: {
            label: 'Length',
            type: 'length-measure',
            defaultValue: {
                length: 100,
                unit: 'cm'
            }
        },
        diameter: {
            label: "Diameter",
            type: "read-only",
            defaultValue: {
                length: 0,
                unit: 'mm'
            }
        },
        altitude: {
            label: "Altitude",
            type: "length-measure",
            defaultValue: {
                length: 0,
                unit: 'cm'
            }
        },
        // diameter: {
        //     label: "Diameter",
        //     type: "length-measure",
        //     defaultValue: {
        //         length: 0,
        //         unit: 'cm'
        //     }
        // },
        thickness: {
            label: 'thickness',
            type: 'length-measure',
            defaultValue: {
                length: 5
            },
        }
    },

    render2D: function (element, layer, scene) {
        let RADIUS = 5;
        let angle = element.rotation + 90;
        let width = element.properties.get('width').get('length');
        let pipeLength = element.properties.get('length').get('length');
        let unit = element.properties.get('length').get('unit');
        let diameter = element.properties.get('diameter').get('length');
        let diameterText = diameter ? `, Ф${diameter}` : '';
        let distanceText = `${pipeLength.toFixed(2)} ${unit}`;

        let textRotation = 0;
        if (Math.sin(angle * Math.PI / 180) < 0) {
            textRotation = 180;
        }

        let style = { stroke: element.selected ? '#0096fd' : 'black', strokeWidth: "1px", fill: '#ff0000' };
        let secstyle = { stroke: element.selected ? '#0096fd' : 'black', strokeWidth: "1px", fill: '#0000ff' };

        return (
            <g transform={`scale(${width * 0.05} ${width * 0.05}) translate(-2, 2)`}>
                <circle key='1' cx='0' cy='0' r={RADIUS} style={style} />
                <circle key='2' cx='12' cy='0' r={RADIUS} style={secstyle} />
                <text key="8" x="0" y="0"
                    transform={`translate(30, -20) scale(1,-1) rotate(${textRotation})`}
                    style={{ textAnchor: "middle", fontSize: "8px", fontFamily: "'Courier New', Courier, monospace", fontWeight: "bold" }}>
                    <tspan>{distanceText}{diameterText}</tspan>
                </text>
            </g>
        )
    },


    render3D: function (element, layer, scene) {
        let mesh = new Three.Mesh();
        return Promise.resolve(mesh);
    },

    renderAxonomertic: function (element, layer, scene, pipeAngle) {

        let pipeLength = element.properties.get('length').get('length');
        let unit = element.properties.get('length').get('unit');
        let diameter = element.properties.get('diameter').get('length');
        let diameterText = diameter ? `, Ф ${diameter}` : '';
        let distanceText = `${pipeLength.toFixed(2)} ${unit}`;
        let altitude = element.getIn(['properties', 'altitude']) ? element.getIn(['properties', 'altitude', 'length']) : 0;
        // let angle = element.rotation + 90;
        // let textRotation = 0;
        // if (Math.sin(angle * Math.PI / 180) < 0) {
        //     textRotation = 180;
        // }

        let rotateAngle = 30 - pipeAngle;

        return (
            <g transform={`rotate(${rotateAngle})`}>
                <line x1="0" y1={altitude} x2="0" y2={pipeLength + altitude} stroke={"#ff0000"} strokeWidth="2px" strokeLinecap="round" transform='scale(1,1.15)' />
                <line x1="6" y1={altitude} x2="6" y2={pipeLength + altitude} stroke={"#0000ff"} strokeWidth="2px" strokeDasharray="10 5" strokeLinecap="round" transform='scale(1,1.15)' />
                <text key="8" x="0" y="0"
                    transform={`translate(20, ${pipeLength / 2}) scale(1,-1) rotate(${rotateAngle})`}
                    style={{ textAnchor: "left", fontSize: "11px" }}>
                    <tspan>{distanceText}{diameterText}</tspan>
                </text>
            </g>
        )
    }

};
